import React, {useEffect, useState, useRef, useMemo} from 'react'
import { Excalidraw, exportToCanvas, restore } from "@excalidraw/excalidraw";
import PropTypes, { func } from 'prop-types'
import forms, { common, isFieldVersion } from './forms'
import keyMapping from './mapping'
import { Formik } from 'formik'
import { decodeEntity } from 'html-entities'
import styles from './styles.module.scss'

import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import LoadingButton from '@mui/lab/LoadingButton'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import ruLocale from 'date-fns/locale/ru'
import DateTimePicker from '@mui/lab/DateTimePicker'
import EmployeeField from "../../../components/Relations/EmployeeField"
import Typography from '@mui/material/Typography'
import { distinct } from '../../../models/data/EntityCollectionModel'
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  ListItem,
  ListItemIcon,
  ListItemText,
  FormGroup,
  Checkbox,
  Stack,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import {Select} from 'antd'
import Select2 from '@mui/material/Select'
import SunEditor from 'suneditor-react'
import 'suneditor/dist/css/suneditor.min.css'
import table from 'suneditor/src/plugins/submenu/table'
import image from 'suneditor/src/plugins/dialog/image'
import list from 'suneditor/src/plugins/submenu/list'
import {font, fontSize, video} from 'suneditor/src/plugins'

import htmlConverter from 'html2json'
import { mapProtocolFieldNumber } from '../../../functions/viewDataMap'
import {mappingActToProtocolData} from "../../../functions/mapping/protocols";
import {mappingObjectReferralToProtocolData, mappingReferralToProtocolData} from "../../../functions/mapping/protocolsReferral";
import { DatePicker } from '@mui/lab'
import {useDropzone} from "react-dropzone";
import {CloudUpload, InsertDriveFile} from "@material-ui/icons";
import Paper from "@mui/material/Paper";
import List from "@mui/material/List";
import { asJSONSafe, normalizeAccreditationRow, parseJsonSafe, resolveProtocolLogoName, toUIJson } from '../../../functions'
import { attachTableColumnResize } from '../../../functions/sunEditorExtensions'
import logos, { filialsMapping } from '../PDFGenerator/logos'
import optionalLogo from '../PDFGenerator/logos/common/ilac_mra.png';
import useRoles from '../../../hooks/useRoles'
import { addRange, selectMany } from '../../../functions/linqSimulation'
import { toUIDate } from '../../../functions/dateHelpers'
import { mappingModel } from '../../../data/schemas/mappingModel'
import MappingRouteTracker from '../../../components/MappingRoute/MappingRouteTracker'
import { equals, page, where } from '../../../functions/resourceLinq1'
import useResourceLinq from '../../../data/useResourceLinq'
import { accreditationCRUD, accreditationIndicatorCRUD } from '../../../http'
import {
  getOrCreateIdbOnly,
  PROTOCOL_ACCREDITATIONS_IDB_CACHE_KEY,
  PROTOCOL_ACCREDITATIONS_IDB_TTL_MIN,
} from '../../../services/cacheService'
import AIRecognizeProtocol from '../Popups/AIRecognizeProtocol'
import { useTranslation } from 'react-i18next'
import {
  buildAccreditationInfoFromIndicator,
  findAccreditationIndicatorByName,
  getSignBase64,
} from '../../../functions/accreditationProtocolFill'


const defaults = {
  number: 0,
  switch: 0,
  string: '',
  datetime: null,
  table: undefined
}

const validators = {
  number: () => true,
  switch: () => true,
  text: () => true,
  file: () => true,
  sketch: () => true,
  employee: () => true,
  date: (date, required) => {
    const isEmpty = date === null || date === '' || date === undefined;

    if (isEmpty && !required)
      return true;

    const result = isEmpty || (date !== 'Invalid Date' && date instanceof Object && !isNaN(date));

    try {
      if (!result && (date || "").endsWith("Z")) {

          const parsedDate = new Date(result);
          return true;
      }
    }
    catch (e) {
      console.error(e);
      return false;
    }

    return result;
  },
  datetime: (date, required) => {
    const isEmpty = date === null || date === '' || date === undefined;

    if (isEmpty && !required)
      return true;

    const result = isEmpty || (date !== 'Invalid Date' && (date instanceof Date || date.getDate) && !isNaN(date));

    try {
      if (!result) {
        const isString = typeof date === 'string' || date instanceof String;

        if (isString && (date || "").endsWith("Z")) {
          const parsedDate = new Date(result);
          return true;
        }
      }
    }
    catch (e) {
      console.error(e);
      return false;
    }

    return result;
  },
  table: () => true
}

ProtocolForms.propTypes = {
  protocolID: PropTypes.number,
  formID: PropTypes.number,
  protocolData: PropTypes.object,
  handleGetProtocol: PropTypes.func,
  onSubmit: PropTypes.func,
  onEdit: PropTypes.func,
  allowedProtocols: PropTypes.array,
}


const {Option} = Select

export default function ProtocolForms(props) {
  const {t} = useTranslation();

  const [initialValues, setInitialValues] = React.useState({})
  const [isActive, setIsActive] = React.useState(false)
  const [results, setResults] = React.useState(null);
  const [formID, setFormID] = React.useState(props.formID)
  const mode = props.protocolID ? 'editing' : 'creating';
  const referral = props?.referral || {};
  console.log(props)
  const act = props.act?.data ? props.act?.data : {};
  const actData = props?.act || {};
  const actNumber = props.act?.form?.number ? props.act?.form?.number : null;
  const jsonProtocolData = toUIJson(props?.protocol?.data)
  const [logo, setLogo] = React.useState(jsonProtocolData? jsonProtocolData ["logoName"] : '')
  const [logoSearch, setLogoSearch] = React.useState('')
  const [availableLogos, setAvailableLogos] = useState(null);
  const [logos, setLogos] = useState(null);
  const [accreditationIndicators, setAccreditationIndicators] = useState([]);
  const [accreditationInfo, setAccreditationInfo] = useState(
    jsonProtocolData?.accreditationInfo || {}
  );
  const [addOptionalLogo, setAddOptionalLogo] = React.useState(jsonProtocolData? jsonProtocolData ["addOptionalLogo"] : false)
  const [employee, setEmployee] = useState(parseJsonSafe(window.localStorage.employee));
  const { isAdministrator } = useRoles();

  const [aiRecognizeOpen, setAIRecognizeOpen] = useState(false);
  
  const saveInitialState = protocol => {
    setInitialValues(
      Object.fromEntries(
        Object.entries(protocol)
          .map(
            ([fieldName, value]) => {
              const field = forms[props.formID.id].fields.find(({ id }) => id === fieldName)
              let fieldValue = value?.value ?? value
              if(field?.type === 'table' && field.htmlTable) {
                fieldValue = htmlConverter.json2html(fieldValue)
              }
              return [fieldName, fieldValue]
            }
          )
      )
    )
  }

  const SketchEditor = ({ value, onChange }) => {
    const excalidrawRef = useRef(null);
  
    const getData = async (api) => {
      if (!api) return null;      
  
      const elements = api.getSceneElements();
      const appState = api.getAppState();
      const files = api.getFiles();

      const result = {
        elements,
        appState,
        files,
        pngBase64: null
      };
  
      const canvas = await exportToCanvas({
        elements,
        appState,
        files: files,
      });
  
      result.pngBase64 = canvas.toDataURL("image/png");
      return result;
    };

    const change = (e) => {
      handleExport(e);
    }
  
    const handleExport = async (e) => {
      if (e?.preventDefault)
        e.preventDefault();
      const data = await getData(excalidrawRef.current);
      if (!data) return;
      onChange(data);
    };
  
    return (
      <div style={{ height: "600px" }}>
        <Button
          variant="contained"
          onClick={handleExport}
          sx={{
            mt: 1.25,
            background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 50%, #64b5f6 100%)',
            color: '#fff',
            boxShadow: '0 3px 5px 2px rgba(25, 118, 210, .3)',
            textTransform: 'none',
            borderRadius: '8px',
            px: 2,
            '&:hover': {
              background: 'linear-gradient(90deg, #1565c0 0%, #1e88e5 50%, #42a5f5 100%)'
            }
          }}
        >
          Сохранить PNG
        </Button>
        <Excalidraw 
          initialData={{
            //appState: value?.appState,
            elements: value?.elements,
            files: value?.files
          }}
          ref={excalidrawRef} />
      </div>
    );
  };
  

  const saveInitialState2 = protocol => {
    return Object.fromEntries(
        Object.entries(protocol)
          .map(
            ([fieldName, value]) => {
              const field = forms[props.formID.id].fields.find(({ id }) => id === fieldName)
              let fieldValue = value?.value ?? value
              if(field?.type === 'table' && field.htmlTable) {
                fieldValue = htmlConverter.json2html(fieldValue)
              }
              return [fieldName, fieldValue]
            }
          )
      )    
  }

  const detectResults = async () =>
  {
    let result = [];

    let formMapsByProtocol = props?.formMaps?.filter(_ => _.protocolForm?.number == formID?.id);
    let resultFormIds = formMapsByProtocol?.map(_ => _.resultFormId);

    if (resultFormIds?.length) {
      let resultFormIdsUn = distinct(resultFormIds, (a, b) => a == b);
      props?.result?.some(r => {
        if (resultFormIdsUn.includes(r.formId)) {
          result.push(r)
        }
      })
    }

    return result;
  };

  const isDate = (date) => date instanceof Date || date.getDate;

  const initializeDefaultValues = (protocol) => {
    const form = forms[formID.id];
    const fields = form.fields;

    const data = {};

    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];

      if (field.type == 'date' || field.type == 'datetime') {
        const value = protocol[field.id];

        if (!value || (isDate(value) && value.getFullYear() <= 1)) {
          data[field.id] = new Date();
        }
      }
    }

    return data;
  }

  const mapResultToProtocol = async () => {

    const results = props?.result;

    if (mode != 'creating' || results.length != 1) 
      return;
      // const parsedData = JSON.parse(act);
      if (Object.keys(act)?.length) {
        return;
      }

      const result = results[0];
      const resultData = asJSONSafe(result.data);
      
      const protocolData = { form: { number: formID.id } };
      await mapModel.map(null, null, resultData, protocolData);
      return protocolData;
      //return mappingActToProtocolData(act, forms?.[formID?.id]?.fields, formID?.id, actNumber)
    
  }

  React.useEffect(async () => {
    // results
    // formMaps
    // formId (protocol)
    if (!formID)
      return;

    try {
      const candidates = await detectResults();

      if (candidates.length > 1) {
        await setResults(candidates);
      }

      // multiple results detected
      // if (candidates?.length > 1) {
      //   return;
      // }

      // switch to protocol view
      let data = await switchToProtocolView2();
      const data2 = await mappingProtocolFromAct2();
      const data3 = await mappingProtocolFromObjectReferral2();
      const data5 = candidates.length == 1 ? await mapResultToProtocol() : {};

      data = {...data, ...data2, ...data3, ...data5};

      const data4 = initializeDefaultValues(data);

      setInitialValues(prevState => ({...prevState, ...data, ...data4}));
    } catch (e) {
      // debugger;
      throw e;
    }
  }, [mode, formID]);

  const switchToProtocolView = async () => {
    try {
    let data = {};
    if (props.handleGetProtocol) {
      data = await props.handleGetProtocol();
    }

    const mapping = keyMapping[formID.id]
    const map = data => Object.fromEntries(
      Object.entries(data)
        .filter(([key,]) => mapping?.[key])
        .map(([key, value]) => ([mapping?.[key] ?? key, value])))
    if(props.protocolData?.act) data = { ...map(props.protocolData.act) }
    if(props.protocolData?.journal) data = { ...map(props.protocolData.journal) }
    saveInitialState(data);
    setIsActive(true);
    } catch (e) {
      // debugger;
      throw e;
    }
  }

  const switchToProtocolView2 = async () => {
    try {
    let data = {};
    if (props.handleGetProtocol) {
      data = await props.handleGetProtocol();
    }

    const mapping = keyMapping[formID.id]
    const map = data => Object.fromEntries(
      Object.entries(data)
        .filter(([key,]) => mapping?.[key])
        .map(([key, value]) => ([mapping?.[key] ?? key, value])))
    if(props.protocolData?.act) data = { ...map(props.protocolData.act) }
    if(props.protocolData?.journal) data = { ...map(props.protocolData.journal) }    
    setIsActive(true);

    const data2 = saveInitialState2(data);

    return {...data, ...data2};
    } catch (e) {
      // debugger;
      throw e;
    }

    return {};
  }

  const mappingProtocolFromAct = () => {
    if (Object.keys(act)?.length) {
      if (mode === 'creating') {
        console.log(act)
        // const parsedData = JSON.parse(act);
        const data = mappingActToProtocolData(act, forms?.[formID?.id]?.fields, formID?.id, actNumber)
        setInitialValues(prevState => ({...prevState, ...data}))
      }
    }
  }
  const mappingProtocolFromAct2 = async () => {
    if (Object.keys(act)?.length) {
      if (mode === 'creating') {
        console.log(act)
        // const parsedData = JSON.parse(act);
        const protocolData = { form: { number: formID.id } };
        await mapModel.map(null, actData, null, protocolData);
        return protocolData;
        //return mappingActToProtocolData(act, forms?.[formID?.id]?.fields, formID?.id, actNumber)
      }
    }

    return {};
  }

  const mappingProtocolFromObjectReferral = () => {
    if (!Object.keys(act)?.length) {
      if (mode === 'creating') {
        const data = mappingObjectReferralToProtocolData(referral, forms?.[formID?.id]?.fields)
        setInitialValues(prevState => ({...prevState, ...data}))
      }
    }
  }

  const mapModel = useMemo(() => new mappingModel(), []);

  const protocolMapCalls = useMemo(() => {
    if (!formID?.id) return [];

    const protocolData = { form: { number: formID.id } };
    const calls = [];

    if (actData?.data) {
      calls.push({
        params: [null, actData, null, { ...protocolData }, null, null, null],
        label: 'Акт → Протокол',
      });
    }

    if (referral && Object.keys(referral).length) {
      calls.push({
        params: [referral, null, null, { ...protocolData }, null, null, null],
        label: 'Заявка → Протокол',
      });
    }

    const resultList = props?.result;
    if (resultList?.length === 1 && resultList[0]?.data) {
      const resultSource = {
        ...asJSONSafe(resultList[0].data),
        form: { number: resultList[0].form?.number },
      };
      calls.push({
        params: [null, null, resultSource, { ...protocolData }, null, null, null],
        label: 'Журнал → Протокол',
      });
    }

    return calls;
  }, [formID, actData, referral, props?.result]);

  const mappingProtocolFromObjectReferral2 = async () => {
    if (!Object.keys(act)?.length) {
      if (mode === 'creating') {
        const protocolData = { form: { number: formID.id } };
        //const resultData = {};        
        await mapModel.map(referral, null, null, protocolData);
        return protocolData;
        //return mappingObjectReferralToProtocolData(referral, forms?.[formID?.id]?.fields)
      }
    }

    return {};
  }

  const mappingProtocolFromReferral = () => {
    if (!Object.keys(act)?.length) {
      if (mode === 'creating') {
        const data = mappingReferralToProtocolData(referral, forms?.[formID?.id]?.fields)
        setInitialValues(prevState => ({...prevState, ...data}))
      }
    }
  }

  const accrediationsResource = useResourceLinq(accreditationCRUD);
  const accreditationIndicatorsResource = useResourceLinq(accreditationIndicatorCRUD);

  useEffect(async () => {
    const matchFilialId =
      employee?.filialId ?? initialValues.filialId ?? props?.protocol?.filialId;
    const matchDivisionId =
      employee?.filialDivisionId ??
      initialValues.filialDivisionId ??
      props?.protocol?.filialDivisionId;

    const logoMappings = filialsMapping
      .filter(logosGroup => {
        if (isAdministrator())
          return true;
        if (matchFilialId == null) return false;
        if (Array.isArray(logosGroup.filialId)) {
            return logosGroup.filialId.includes(matchFilialId)
        } else {
            return logosGroup.filialId === matchFilialId
        }
      });
      // .filter(logosGroup => {
      //   if (isAdministrator())
      //     return true;
      //   if (!logosGroup.filialDivisionId || matchDivisionId == null) return true;
      //     if (Array.isArray(logosGroup.filialDivisionId)) {
      //         return logosGroup.filialDivisionId.includes(matchDivisionId)
      //     } else {
      //         return logosGroup.filialDivisionId === matchDivisionId
      //     }
      // });
    let logos = selectMany(logoMappings, _ => _.logo);
    logos = distinct(logos, (a, b) => a == b);

    //debugger;
    let accreditationQuery = page({}, 0, null);

    const filialId = initialValues.filialId;
    const filialDivisionId = initialValues.filialDivisionId;

    const accreditationFilialForCache = (filialId || props?.protocol?.filialId) ?? null;

    // Знаки в реестре часто только по филиалу (без РО); фильтр по РО отсекал записи.
    if (!isAdministrator()) {
        const qFilial = accreditationFilialForCache || employee?.filialId;
        if (qFilial) {
            accreditationQuery = where(accreditationQuery, {
                filialId: equals(qFilial)
            });
        }
    }

    const accreditationsCacheRequest = isAdministrator()
      ? { scope: "admin" }
      : {
          scope: "filial",
          filialId: accreditationFilialForCache,
        };

    const fetchAccreditationsList = async () => {
      const list = await accrediationsResource.toList(accreditationQuery);
      return list.map(_ =>
        normalizeAccreditationRow({ ..._, sign: asJSONSafe(_.sign) ?? _.sign })
      );
    };

    const shouldUseAccreditationsCache = !isAdministrator();

    const accreditationsRaw = shouldUseAccreditationsCache
      ? await getOrCreateIdbOnly(
        PROTOCOL_ACCREDITATIONS_IDB_CACHE_KEY,
        accreditationsCacheRequest,
        fetchAccreditationsList,
        PROTOCOL_ACCREDITATIONS_IDB_TTL_MIN
      )
      : await fetchAccreditationsList();
    const accreditations2 = (accreditationsRaw || []).map(normalizeAccreditationRow);
    const filteredAccreditations = accreditations2.filter((accreditation) => {
      if (isAdministrator()) return true;

      const accreditationFilialId = accreditation?.filialId ?? accreditation?.FilialId;
      if (matchFilialId == null || String(accreditationFilialId) !== String(matchFilialId)) {
        return false;
      }

      const accreditationDivisionId =
        accreditation?.filialDivisionId ?? accreditation?.FilialDivisionId;
      if (accreditationDivisionId == null || matchDivisionId == null) return true;

      return String(accreditationDivisionId) === String(matchDivisionId);
    });
    setLogos(filteredAccreditations);

    //   debugger;
    // addRange(logos, accreditations2);
    //   const item = logos.filter(_ => _.name == 'KZ.T.06.3019');
    //   console.log('accreditation item:', item);
    setAvailableLogos(logos);

    let indicatorQuery = page({}, 0, null);
    if (!isAdministrator()) {
      const indicatorFilialId = filialId || employee?.filialId || props?.protocol?.filialId;
      if (indicatorFilialId) {
        indicatorQuery = where(indicatorQuery, { filialId: equals(indicatorFilialId) });
      }
    }
    const indicators = await accreditationIndicatorsResource.toList(indicatorQuery);
    setAccreditationIndicators(indicators || []);

}, [props?.protocol, employee?.filialId, employee?.filialDivisionId, initialValues.filialId, initialValues.filialDivisionId]);

  React.useEffect(() => {
    if (mode === 'editing') {
      setAccreditationInfo(toUIJson(props?.protocol?.data)?.accreditationInfo || {});
    }
  }, [mode, props?.protocol?.id, props?.protocol?.data]);

  const handleLogoChange = (value) => {
    setLogo(value);

    const selectedAccreditation = (logos || []).find(
      (accreditation) => getSignBase64(accreditation?.sign) === value
    );
    if (!selectedAccreditation) {
      setAccreditationInfo({});
      return;
    }

    const accreditationName = selectedAccreditation.name || selectedAccreditation.Name ||
      selectedAccreditation.certificateNumber || selectedAccreditation.CertificateNumber || '';
    const indicator = findAccreditationIndicatorByName(
      accreditationIndicators,
      accreditationName,
      selectedAccreditation
    );
    setAccreditationInfo(
      indicator ? buildAccreditationInfoFromIndicator(indicator) : {}
    );
  };

  const updateAccreditationInfoField = (field, value) => {
    setAccreditationInfo((previous) => ({
      ...(previous || {}),
      [field]: value,
    }));
  };

  React.useEffect(() => {
    if (!logo || !logos?.length || !accreditationIndicators?.length) return;

    const selectedAccreditation = logos.find(
      (accreditation) => getSignBase64(accreditation?.sign) === logo
    );
    if (!selectedAccreditation) return;

    const accreditationName = selectedAccreditation.name || selectedAccreditation.Name ||
      selectedAccreditation.certificateNumber || selectedAccreditation.CertificateNumber || '';
    const indicator = findAccreditationIndicatorByName(
      accreditationIndicators,
      accreditationName,
      selectedAccreditation
    );
    if (indicator) {
      setAccreditationInfo(buildAccreditationInfoFromIndicator(indicator));
    }
  }, [logo, logos, accreditationIndicators]);

  React.useEffect(() => {
    if (mode !== "editing" || !props?.protocol?.id) return;
    const d = toUIJson(props?.protocol?.data);
    const ln = d?.logoName;
    if (ln != null && ln !== "") setLogo(ln);
  }, [mode, props?.protocol?.id]);

  React.useEffect(() => {
    if (!logo) return;
    const resolved = resolveProtocolLogoName(logo, availableLogos, logos);
    if (resolved !== logo) setLogo(resolved);
  }, [logo, availableLogos, logos]);

  const logoOptions = [
    { value: '', label: 'Без логотипа', image: null },
    ...(availableLogos || []).map((logoUrl) => ({
      value: logoUrl,
      label: String(logoUrl).split('/').pop() || 'Логотип филиала',
      image: logoUrl,
    })),
  ];

  return (
    isActive === false
      ? <><Autocomplete
        disablePortal
        name='formType'
        value={formID}
        onChange={(_, value) => setFormID(value)}
        noOptionsText='Ничего не найдено'
        isOptionEqualToValue={(option, value) => option.id === value.id}
        options={Object.entries(forms)
          .map(([id, { name }]) => ({ id, label: `№${id} ${name}` }))
          .filter(({ id }) => window.localStorage?.disableFormsFiltering || props.allowedProtocols?.includes(id))
        }
        renderInput={params => <TextField {...params} label='Тип формы' />}
      />
      {results?.length ?
        <>
        <FormControl margin={"normal"} fullWidth>
            <span>Протоколу соотвествует несколько журналов</span>
            <Select
                onChange={async (value) => {
                  await props?.setSelectedResultId(value);
                  await switchToProtocolView();
                  await mappingProtocolFromAct()
                  await mappingProtocolFromObjectReferral()
                  //setIsActive(true)
                }}
                id="objectId"
                value={props.selectedResultId}
                placeholder="Журнал"
            >
                {results && results.map(_ => (
                    <Option key={_.id} value={_.id}>
                        {`${_.id}) ${_.form?.number}) ${_?.number}`}
                    </Option>
                ))}
            </Select>
        </FormControl>
        </>
         : <></>}
      </>
      : <>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Тип формы: {forms[formID.id].name}
        </Typography>
        <Formik
            enableReinitialize
            initialValues={initialValues}
            validateOnChange={false} validateOnBlur={false}
            validate={values => {
            const errors = {}
            forms[formID.id].fields.forEach(field => {
              let value = values[field.id]
              if(field.type === 'switch') values[field.id] = value ?? 0;

              let required = true;

              if (field.required == false) {              
                required = false;
              }
              // if(field.type === 'employee') values[field.id] = value?.fullName
              if(!validators[field.type]?.(value, required)) {
                // debugger;
                return errors[field.id] = 'Заполните поле';
              }
            })
            
            // Валидация подписантов - должно быть выбрано минимум 2 подписанта
            if (mode === 'creating') {
              const signers = [];
              if (values.research_specialist) signers.push(values.research_specialist);
              if (values.lab_director) signers.push(values.lab_director);
              if (values.organization_leader) signers.push(values.organization_leader);
              
              if (signers.length < 2) {
                errors.signers = 'Должно быть выбрано минимум 2 подписанта';
              }
            }
            
            return errors
          }}
          onSubmit={(values, { setSubmitting }) => {
            const resultValues = Object.fromEntries(Object.entries(values).map(([fieldID, value]) => {
              //let newValue = JSON.parse(JSON.stringify(value))
              let newValue = value;
              const fieldInfo = [...forms[formID.id].fields, ...common].find(({ id }) => id === fieldID)
            
              if (!fieldInfo) {
                return [fieldID, null];
              }
            
              if(fieldInfo.type === 'table' && fieldInfo.htmlTable) {
                // Удаляем кнопки редактирования перед конвертацией в JSON
                newValue = removeEditButtonsFromHtml(newValue);
                newValue = htmlConverter.html2json(newValue);
              }
              return [fieldID, newValue]
            }))
              if(logo)
                resultValues.logoName = logo;
              resultValues.accreditationInfo = accreditationInfo || null;
              if(addOptionalLogo)  
                resultValues.addOptionalLogo = addOptionalLogo;
            props[mode === 'creating' ? 'onSubmit' : 'onEdit'](resultValues, formID.id).then(() => setSubmitting(false))
          }}
        >
          {({
            values,
            errors,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            setTouched,
            touched,
            setFieldError
          }) => {
            const fields = forms?.[formID?.id]?.fields
            if(fields && Object.keys(touched).length !== fields.length)
              setTouched(Object.fromEntries(fields.map(({ id }) => [id, true])))
            return (
              <form onSubmit={handleSubmit} className={styles.form}>
                <Grid item xs={6}>
                  {isAdministrator() && <>
                    <Button
                      variant='contained'
                      disabled={isSubmitting || !formID}
                      style={{"min-height": "40px"}}
                      onClick={() => {
                        setAIRecognizeOpen(true);
                      }}
                    >
                      {'Функция распознавания'}
                    </Button>
                    <MappingRouteTracker
                      mapModel={mapModel}
                      mapCalls={protocolMapCalls}
                      enabled={protocolMapCalls.length > 0}
                    />
                  </>}
                </Grid>
                      <Grid item xs={12}>
                        <Stack spacing={2} sx={{marginTop: 2}}>
                          <div>                          
                          <TextField
                              fullWidth
                              value={logoSearch}
                              onChange={(event) => setLogoSearch(event.target.value)}
                              label='Поиск знака аккредитации'
                              size='small'
                              sx={{ display: 'none' }}
                          />
                          <FormControl fullWidth>
                              <InputLabel id='logo-select'>Выберите логотип для документа</InputLabel>
                              <Select2
                                  labelId='logo-select'
                                  id="demo-simple-select"
                                  value={logo}
                                  label='Выберете логотип для документа'
                                  onChange={({target: {value}}) => handleLogoChange(value)}
                                  renderValue={(selected) =>
                                    selected ? (
                                      <img
                                        src={selected}
                                        alt=""
                                        style={{ height: 48, maxWidth: "100%", objectFit: "contain" }}
                                      />
                                    ) : (
                                      "Без логотипа"
                                    )
                                  }
                              >
                                  <MenuItem
                                      disableRipple
                                      disableGutters
                                      sx={{
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 1,
                                        backgroundColor: 'background.paper',
                                        '&:hover': { backgroundColor: 'background.paper' },
                                      }}
                                      onClick={(event) => event.stopPropagation()}
                                  >
                                      <TextField
                                          autoFocus
                                          fullWidth
                                          size='small'
                                          label='Поиск знака аккредитации'
                                          value={logoSearch}
                                          onChange={(event) => setLogoSearch(event.target.value)}
                                          onKeyDown={(event) => event.stopPropagation()}
                                          onClick={(event) => event.stopPropagation()}
                                      />
                                  </MenuItem>
                                  <MenuItem value=''>
                                      Без логотипа
                                  </MenuItem>
                                  {availableLogos && availableLogos
                                    .filter((logoURL) => {
                                      const query = logoSearch.trim().toLowerCase();
                                      return !query || String(logoURL).toLowerCase().includes(query);
                                    })
                                    .map(logoURL => (
                                      <MenuItem value={logoURL} key={logoURL}>
                                          <img src={logoURL} alt='Логотип филиала'
                                                style={{height: 70}}/>
                                      </MenuItem>
                                  ))}
                                  {availableLogos?.includes(logo) && availableLogos
                                    .filter((logoURL) => {
                                      const query = logoSearch.trim().toLowerCase();
                                      return !query || String(logoURL).toLowerCase().includes(query);
                                    })
                                    .map((logoURL) => (
                                      <MenuItem value={logoURL} key={logoURL}>
                                        <img
                                          src={logoURL}
                                          alt='Логотип филиала'
                                          style={{ height: 70 }}
                                        />
                                      </MenuItem>
                                    ))}
                                  {logos && logos
                                    .filter(_ => {
                                      const query = logoSearch.trim().toLowerCase();
                                      const searchableText = [
                                        _.name,
                                        _.Name,
                                        _.certificateNumber,
                                        _.CertificateNumber,
                                      ]
                                        .filter(Boolean)
                                        .join(' ')
                                        .toLowerCase();
                                      if (query && !searchableText.includes(query)) return false;
                                      return true;
                                    })
                                    .map(_ => (
                                    <MenuItem value={_.sign?.base64} key={_.id}>
                                        <img src={_.sign?.base64} alt='Логотип филиала'
                                            style={{ height: 70 }} />
                                        {/* <label>{_.name}</label> */}
                                    </MenuItem>
                                  ))}
                              </Select2>
                          </FormControl>
                          </div>
                          <div>
                            <FormGroup>
                              <FormControlLabel
                                  control={<Checkbox checked={addOptionalLogo}
                                                      onChange={(_, value) => setAddOptionalLogo(value)}/>}
                                  label='Добавить логотип ilac-MRA'
                              />
                            </FormGroup>  
                          </div>
                        </Stack>
                      </Grid>

                      {logo && (
                        <Grid item xs={12}>
                          <Typography variant="subtitle2" sx={{ marginBottom: 1 }}>
                            Данные аттестата аккредитации (для PDF)
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                              <TextField
                                fullWidth
                                label="Дата регистрации KZ (как в тексте)"
                                value={accreditationInfo.registeredAtKz || accreditationInfo.registeredAt || ''}
                                onChange={(event) => updateAccreditationInfoField('registeredAtKz', event.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <TextField
                                fullWidth
                                label="№ знака (например KZ.Т.14.Е 1213)"
                                value={accreditationInfo.markNumber || accreditationInfo.markName || ''}
                                onChange={(event) => updateAccreditationInfoField('markNumber', event.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <TextField
                                fullWidth
                                label="Срок действия до KZ (как в тексте)"
                                value={accreditationInfo.validUntilKz || accreditationInfo.validUntil || ''}
                                onChange={(event) => updateAccreditationInfoField('validUntilKz', event.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Дата регистрации RU (как в тексте)"
                                value={accreditationInfo.registeredAtRu || accreditationInfo.registeredAt || ''}
                                onChange={(event) => updateAccreditationInfoField('registeredAtRu', event.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Срок действия до RU (как в тексте)"
                                value={accreditationInfo.validUntilRu || accreditationInfo.validUntil || ''}
                                onChange={(event) => updateAccreditationInfoField('validUntilRu', event.target.value)}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                {formID !== null && initialValues && (() => {
                  let fieldNumber = 0;
                  return [...forms[formID.id].fields, ...common].map((fieldInfo, i) => {
                  if(fieldInfo.type === 'employee') {
                    //debugger;
                  }
                  const defaultProps = {
                    error: Boolean(errors[fieldInfo.id]),
                    helperText: errors[fieldInfo.id],
                    id: fieldInfo.id,
                    name: fieldInfo.id,
                    label: fieldInfo.label,
                    value: values?.[fieldInfo.id] ?? defaults[fieldInfo.type],
                    onChange: eventOrValue => {
                      try {
                      } catch (e) {

                      }

                      //research_specialist, lab_director, organization_leader
                      if(eventOrValue?.type === 'change') {
                        handleChange(eventOrValue)
                      }
                      else {
                        if (eventOrValue) {
                          switch (fieldInfo.id) {
                            case 'research_specialist':
                            case 'lab_director':
                            case 'organization_leader':
                              const specialistId = fieldInfo.id == 'research_specialist' ? eventOrValue.id : values.research_specialist?.id;
                              const directorId = fieldInfo.id == 'lab_director' ? eventOrValue.id : values.lab_director?.id;
                              const leaderId = fieldInfo.id == 'organization_leader' ? eventOrValue.id : values.organization_leader?.id;

                              if ((specialistId && directorId && specialistId == directorId) || (directorId && leaderId && directorId == leaderId) || (specialistId && leaderId && specialistId == leaderId)) {
                                alert('Нельзя выбирать одинаковых сотрудников для подписания!');
                                return;
                              }
                              break;
                          }
                        }
                        
                        setFieldValue(fieldInfo.id, eventOrValue)
                        
                        // Принудительная перевалидация при изменении полей подписантов
                        if (fieldInfo.id === 'research_specialist' || fieldInfo.id === 'lab_director' || fieldInfo.id === 'organization_leader') {
                          setTimeout(() => {
                            const newValues = { ...values, [fieldInfo.id]: eventOrValue };
                            const signers = [];
                            if (newValues.research_specialist) signers.push(newValues.research_specialist);
                            if (newValues.lab_director) signers.push(newValues.lab_director);
                            if (newValues.organization_leader) signers.push(newValues.organization_leader);
                            
                            // Перевалидация подписантов
                            if (mode === 'creating') {
                              if (signers.length < 2) {
                                setFieldError('signers', 'Должно быть выбрано минимум 2 подписанта');
                              } else {
                                // Очищаем ошибку если выбрано достаточно подписантов
                                setFieldError('signers', undefined);
                              }
                            }
                          }, 0);
                        }
                      }
                    }
                  }
                  const sharedProps = { ...defaultProps, ...fieldInfo.props }
                  const fields = {
                    text: <TextField />,
                    number: <TextField type='number' />,
                    date: <Date2 />,
                    datetime: <DateTime />,
                    file: <File />,
                    sketch: <SketchEditor />,
                    switch: <Switch options={fieldInfo.options} />,
                    employee: <EmployeeField label=' ' object={sharedProps.value} />,
                    table: fieldInfo.htmlTable
                      ? (fieldInfo.controllable 
                          ? <TableNewControllable data={fieldInfo.htmlTable} fieldInfo={fieldInfo} />
                          : <TableNew data={fieldInfo.htmlTable} fieldInfo={fieldInfo} />)
                      : <TableOld data={fieldInfo.rows} />,
                    label: <div></div>
                  }
                  if(fieldInfo.type === 'employee') {
                    delete sharedProps.label
                  }

                  let protocolVersion = forms[formID.id].version;

                  if (!protocolVersion) {
                    protocolVersion = 1;
                  }

                  if (fieldInfo.htmlTable && !isFieldVersion(fieldInfo, protocolVersion)) {
                    return <></>;
                  }

                  const currentFieldNumber = fieldNumber;
                  if (!fieldInfo.skipNumber && fieldInfo.type !== 'table') {
                    fieldNumber++;
                  }

                  return <div key={i} className={styles.field}>
                    {fieldInfo.type !== 'table' &&
                      <div>{fieldInfo.type === 'employee' ? '':`${mapProtocolFieldNumber(fieldInfo.number, currentFieldNumber, fieldInfo.skipNumber)}`}{fieldInfo.label}</div>
                    }
                    <div style={{ maxWidth: '100%' }}>{React.cloneElement(fields[fieldInfo.type], sharedProps)}</div>
                  </div>
                })})()}
                {errors.signers && (
                  <Typography 
                    variant="body2" 
                    color="error" 
                    sx={{ marginBottom: '10px', fontSize: '14px' }}
                  >
                    {errors.signers}
                  </Typography>
                )}
                <LoadingButton
                  variant='contained'
                  type='submit'
                  loading={isSubmitting}
                  disabled={!formID}
                  style={{"min-height": "40px"}}
                >
                  {mode === 'creating' ? 'Создать протокол' : 'Сохранить протокол'}
                </LoadingButton>
              </form>
            )
          }}
        </Formik>
        <AIRecognizeProtocol data={jsonProtocolData} action={'recognize'} title={t("protocolList.recognizeText")} open={aiRecognizeOpen} setOpen={setAIRecognizeOpen}/>
      </>
  )
}

Switch.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  options: PropTypes.array,
  label: PropTypes.string,
}
function Switch({ value, onChange, ...props }) {
  // const tabsStyles = appleTabsStylesHook.useTabs()
  // const tabItemStyles = appleTabsStylesHook.useTabItem()

  React.useEffect(() => {
    if(onChange && (value === undefined || value === null)) onChange(0)
  }, [onChange, value])

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">
        {props.options.label}
      </FormLabel>
      <RadioGroup
        aria-label="gender"
        name="controlled-radio-buttons-group"
        value={value}
        onChange={(e, index) => onChange(index)}
      >
        {props.options.map(option => (
            <FormControlLabel
                key={option}
                value={option}
                control={<Radio />}
                label={option}
            />
        ))}
      </RadioGroup>
    </FormControl>

    // <Tabs
    //   classes={tabsStyles}
    //   value={value}
    //   onChange={(e, index) => onChange(index)}
    //   {...props}
    // >
    //   {props.options.map(option => <Tab classes={tabItemStyles} disableRipple label={option} key={option} />)}
    // </Tabs>
  )
}

function Date2({ onChange, value, ...sharedProps }) {
  // React.useEffect(() => {
  //   if(!onChange) return
  //   if(typeof value === 'string') onChange?.(new Date(value))
  //   else if(value === null) onChange?.(new Date())
  // }, [onChange, value])

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ruLocale}>
      <DatePicker
        renderInput={props => <TextField {...props} error={sharedProps.error} helperText={sharedProps.helperText} />}
        showTodayButton
        onChange={onChange}
        value={value}
        {...sharedProps}
      />
    </LocalizationProvider>
  )
}

function DateTime({ onChange, value, ...sharedProps }) {
  // React.useEffect(() => {
  //   if(!onChange) return
  //   if(typeof value === 'string') onChange?.(new Date(value))
  //   else if(value === null) onChange?.(new Date())
  // }, [onChange, value])

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ruLocale}>
      <DateTimePicker
        renderInput={props => <TextField {...props} error={sharedProps.error} helperText={sharedProps.helperText} />}
        showTodayButton
        onChange={onChange}
        value={value}
        {...sharedProps}
      />
    </LocalizationProvider>
  )
}

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

function File({ value, onChange, ...props }) {

  const {acceptedFiles, getRootProps, getInputProps} = useDropzone({
    onDrop: acceptedFiles1 => {
      toBase64(acceptedFiles1[0]).then(r => {
        onChange(r)
      })
    },
    multiple: false,
    maxFiles: 1,
    accept: {
      'image/jpeg': [],
      'image/png': []
    }
  });

  return (
      <>
        <Paper {...getRootProps()} sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} variant="outlined">
          <CloudUpload/>
          <input {...getInputProps()} multiple={false}/>
          <p>Перетащите файл или нажмите сюда</p>
        </Paper>
        <List>
          {
            acceptedFiles.map((f, index) => (
                <ListItem key={index}>
                  <ListItemIcon>
                    <InsertDriveFile/>
                  </ListItemIcon>
                  <ListItemText primary={f.name} secondary={f.size}/>
                </ListItem>
            ))
          }
        </List>
      </>
  )
}

function TableOld(props) {
  React.useEffect(() => {
    if(!props.value) {
      props.onChange(props.data.map(row => row.map(cell => decodeEntity(cell))))
    }
  }, [props.value])

  const changeCell = (x, y) => e => {
    props.value[y][x] = e.target.value
    props.onChange(props.value)
  }

  return (
    <div className={styles.table}>
      {props.data.map((row, i) => (
        <div className={styles.row} key={i}>
          {row.map((cell, j) => (
            <div className={styles.cell} key={j}>
              <textarea value={props.value?.[i]?.[j]} onInput={changeCell(j, i)} />
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

/**
 * Удаляет кнопки редактирования и удаления строк из HTML
 * @param {string} html - HTML строка
 * @returns {string} - очищенный HTML
 */
const removeEditButtonsFromHtml = (html) => {
  if (!html || typeof html !== 'string') {
    return html;
  }

  try {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    // Удаляем кнопки редактирования и удаления
    const buttons = tempDiv.querySelectorAll('.edit-row-button, .delete-row-button');
    buttons.forEach(button => button.remove());
    
    // Также удаляем атрибут position: relative со строк, если он был добавлен только для кнопок
    const rowsWithPosition = tempDiv.querySelectorAll('tr[style*="position: relative"]');
    rowsWithPosition.forEach(row => {
      const hasButtons = row.querySelector('.edit-row-button, .delete-row-button');
      if (!hasButtons) {
        const style = row.getAttribute('style') || '';
        const newStyle = style.replace(/position:\s*relative[^;]*;?/gi, '').trim();
        if (newStyle) {
          row.setAttribute('style', newStyle);
        } else {
          row.removeAttribute('style');
        }
      }
    });
    
    return tempDiv.innerHTML;
  } catch (e) {
    console.warn('Failed to remove edit buttons from HTML:', e);
    return html;
  }
};

const normalizePastedTableHtml = (html) => {
  if (!html || typeof html !== 'string' || !html.includes('<table')) {
    return html;
  }

  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const tables = doc.querySelectorAll('table');

    const ptToPx = 96 / 72;
    const parseLengthToPx = (value) => {
      if (!value) return null;
      const str = String(value).trim();
      const match = str.match(/^([0-9.]+)\s*(px|pt|%|cm|mm|in)?$/i);
      if (!match) return null;
      const num = parseFloat(match[1]);
      const unit = (match[2] || 'px').toLowerCase();
      if (Number.isNaN(num)) return null;
      if (unit === 'in') return num * 96;
      if (unit === 'cm') return (num * 96) / 2.54;
      if (unit === 'mm') return (num * 96) / 25.4;
      if (unit === 'pt') return num * ptToPx;
      if (unit === '%') return null;
      return num;
    };

    const parseMsoWidthAltToPx = (styleText) => {
      if (!styleText) return null;
      const match = String(styleText).match(/mso-width-alt:\s*([0-9.]+)/i);
      if (!match) return null;
      const twips = parseFloat(match[1]);
      if (Number.isNaN(twips)) return null;
      // mso-width-alt хранится в twips (1/20 pt)
      const pt = twips / 20;
      return pt * ptToPx;
    };

    const isVerticalStyle = (styleText) => {
      if (!styleText) return false;
      const s = String(styleText).toLowerCase();
      return (
        s.includes('mso-rotate') ||
        s.includes('writing-mode') ||
        s.includes('text-orientation:') ||
        s.includes('vertical-rl') ||
        s.includes('vertical-lr') ||
        s.includes('tb-rl')
      );
    };

    tables.forEach((table) => {
      table.classList.add('pasted-table');

      let columns = Array.from(table.querySelectorAll('colgroup col'));
      let widths = columns.map((col) => {
        const fromWidth = parseLengthToPx(col.style.width || col.getAttribute('width'));
        if (fromWidth) return fromWidth;
        return parseMsoWidthAltToPx(col.getAttribute('style'));
      });

      if (widths.filter(Boolean).length === 0) {
        const firstRow = table.querySelector('tr');
        if (firstRow) {
          const cells = Array.from(firstRow.children).filter(
            (cell) => cell.tagName === 'TD' || cell.tagName === 'TH'
          );
          const cellWidths = cells.map((cell) => {
            const fromWidth = parseLengthToPx(cell.style.width || cell.getAttribute('width'));
            if (fromWidth) return fromWidth;
            return parseMsoWidthAltToPx(cell.getAttribute('style'));
          });
          if (cellWidths.some(Boolean)) {
            columns = cells;
            widths = cellWidths;
          }
        }
      }

      const total = widths.reduce((sum, w) => sum + (w || 0), 0);
      if (total > 0) {
        // Сохраняем исходные ширины столбцов из Word, не растягиваем до 100%
        table.style.tableLayout = 'fixed';
        table.style.width = `${total.toFixed(0)}px`;
        table.style.maxWidth = 'none';
        table.style.margin = '0';
        widths.forEach((w, idx) => {
          if (!w || !columns[idx]) return;
          columns[idx].style.width = `${w.toFixed(2)}px`;
          columns[idx].removeAttribute('width');
        });
      } else {
        // Если ширины не найдены — не фиксируем таблицу, чтобы избежать растягивания
        table.style.tableLayout = 'auto';
        table.style.width = 'auto';
        table.style.maxWidth = 'none';
      }

      const verticalCandidates = table.querySelectorAll('[style]');
      verticalCandidates.forEach((el) => {
        if (isVerticalStyle(el.getAttribute('style'))) {
          el.classList.add('vertical-text');
          el.style.removeProperty('writing-mode');
          el.style.removeProperty('text-orientation');
          el.style.removeProperty('mso-rotate');
        }
      });
    });

    return doc.body.innerHTML;
  } catch (e) {
    return html;
  }
};

const getClosestCellNode = (node) => {
  if (!node) return null
  const el = node.nodeType === 3 ? node.parentNode : node
  if (!el) return null

  if (typeof el.closest === 'function') {
    return el.closest('td, th')
  }

  let cur = el
  while (cur && cur.nodeName) {
    const tag = String(cur.nodeName).toUpperCase()
    if (tag === 'TD' || tag === 'TH') return cur
    cur = cur.parentNode
  }

  return null
}

const collectTableCellVerticalNodes = (cell) => {
  if (!cell || !cell.querySelectorAll) return [cell].filter(Boolean)
  const seen = new Set()
  const out = []
  const push = (n) => {
    if (!n || seen.has(n)) return
    seen.add(n)
    out.push(n)
  }
  push(cell)
  cell.querySelectorAll('[style]').forEach(push)
  // Элементы только с классом (без inline style) тоже должны участвовать в clear/apply симметрично
  cell.querySelectorAll('.vertical-text').forEach(push)
  return out
}

const stripVerticalFromStyleAttribute = (el) => {
  const raw = el.getAttribute && el.getAttribute('style')
  if (!raw) return
  let s = String(raw)
    .replace(/writing-mode\s*:\s*[^;]+;?/gi, '')
    .replace(/text-orientation\s*:\s*[^;]+;?/gi, '')
    .replace(/mso-rotate\s*:\s*[^;]+;?/gi, '')
    .replace(/;\s*;/g, ';')
    .replace(/^\s*;\s*|\s*;\s*$/g, '')
    .trim()
  if (s) el.setAttribute('style', s)
  else el.removeAttribute('style')
}

const stripVerticalTextClassAttribute = (el) => {
  const raw = el.getAttribute && el.getAttribute('class')
  if (!raw) return
  const next = String(raw)
    .split(/\s+/)
    .filter((c) => c && c !== 'vertical-text')
    .join(' ')
    .trim()
  if (next) el.setAttribute('class', next)
  else el.removeAttribute('class')
}

const applyVerticalTextToCell = (cell) => {
  if (!cell || !cell.style) return
  collectTableCellVerticalNodes(cell).forEach((node) => {
    if (!node || !node.style) return
    // sideways-lr по спецификации: горизонтальный текст как колонка с поворотом против часовой («влево»).
    // vertical-rl + text-orientation в браузерах часто даёт «вправо» и плохо сочетается с SunEditor.
    node.style.setProperty('writing-mode', 'sideways-lr')
    node.style.removeProperty('text-orientation')
    node.style.removeProperty('mso-rotate')
    if (node.classList) node.classList.add('vertical-text')
    const tag = node.tagName && String(node.tagName).toUpperCase()
    if (tag === 'TD' || tag === 'TH') {
      node.style.setProperty('vertical-align', 'middle')
      node.style.setProperty('text-align', 'center')
    }
  })
}

const clearVerticalTextFromCell = (cell) => {
  if (!cell) return
  collectTableCellVerticalNodes(cell).forEach((node) => {
    if (!node) return
    if (node.style) {
      node.style.removeProperty('writing-mode')
      node.style.removeProperty('text-orientation')
      node.style.removeProperty('mso-rotate')
    }
    if (node.classList) node.classList.remove('vertical-text')
    stripVerticalFromStyleAttribute(node)
    stripVerticalTextClassAttribute(node)
  })
}

function createTableVerticalTextPlugins(onChangeRef) {
  const pushUpdatedHtml = (core) => {
    try {
      const updatedHtml = core.getContents?.(true)
      if (updatedHtml != null && typeof onChangeRef.current === 'function') {
        onChangeRef.current(updatedHtml)
      }
    } catch (_) {}
  }

  return [
    {
      name: 'toggleVerticalText',
      display: 'command',
      title: 'Перевернуть текст вертикально',
      innerHTML: '<span class="se-icon-text">V</span>',
      add: function (core) {
        core.context.toggleVerticalText = {}
      },
      action: function () {
        const selectionNode = this.getSelectionNode?.() || null
        const cell = getClosestCellNode(selectionNode)
        if (!cell) return
        applyVerticalTextToCell(cell)
        pushUpdatedHtml(this)
      }
    },
    {
      name: 'toggleHorizontalText',
      display: 'command',
      title: 'Вернуть текст обратно',
      innerHTML: '<span class="se-icon-text">H</span>',
      add: function (core) {
        core.context.toggleHorizontalText = {}
      },
      action: function () {
        const selectionNode = this.getSelectionNode?.() || null
        const cell = getClosestCellNode(selectionNode)
        if (!cell) return
        clearVerticalTextFromCell(cell)
        const core = this
        requestAnimationFrame(() => pushUpdatedHtml(core))
      }
    }
  ]
}

function TableNew(props) {
  const sunEditorInstanceRef = React.useRef(null)
  const onChangeRef = React.useRef(props.onChange)
  onChangeRef.current = props.onChange

  const tableVerticalTextPlugins = React.useMemo(
    () => createTableVerticalTextPlugins(onChangeRef),
    []
  )

  const noContent = !props.value || /^<p>([\u200B\s]|<br>)*<\/p>$/.test(props.value)
  React.useEffect(() => {
    if(noContent) {
      props.onChange(props.data)
    }
  }, [props.value])

  function handleEditorLoad(sunEditor) {
    sunEditorInstanceRef.current = sunEditor
    attachTableColumnResize(sunEditor, (html) => { if (onChangeRef.current) onChangeRef.current(html) })
  }

  const applyFontToTable = React.useCallback((fontSize) => {
    if (!sunEditorInstanceRef.current) {
      console.warn('SunEditor instance not available')
      return
    }

    try {
      // Получаем текущий HTML из редактора
      let currentHtml = sunEditorInstanceRef.current.getContents(true) || props.value || props.data
      
      // Создаем временный DOM элемент для парсинга HTML
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = currentHtml
      
      // Находим таблицу
      const table = tempDiv.querySelector('table')
      if (!table) {
        console.warn('Table not found')
        return
      }
      
      // Применяем шрифт и размер ко всем ячейкам таблицы
      const cells = table.querySelectorAll('td, th')
      cells.forEach(cell => {
        // Получаем текущий стиль или создаем новый
        let style = cell.getAttribute('style') || ''
        
        // Удаляем старые значения font-family и font-size
        style = style.replace(/font-family:\s*[^;]+;?/gi, '')
        style = style.replace(/font-size:\s*[^;]+;?/gi, '')
        style = style.replace(/font:\s*[^;]+;?/gi, '')
        
        // Добавляем новый шрифт и размер
        style = `font-family: Times New Roman; font-size: ${fontSize}pt; ${style}`.trim()
        
        // Удаляем лишние пробелы и точки с запятой
        style = style.replace(/;\s*;/g, ';').replace(/^\s*;\s*/, '').replace(/\s*;\s*$/, '')
        
        cell.setAttribute('style', style)
        
        // Также применяем к вложенным элементам (span, p, div и т.д.)
        const innerElements = cell.querySelectorAll('span, p, div, font')
        innerElements.forEach(el => {
          let elStyle = el.getAttribute('style') || ''
          elStyle = elStyle.replace(/font-family:\s*[^;]+;?/gi, '')
          elStyle = elStyle.replace(/font-size:\s*[^;]+;?/gi, '')
          elStyle = elStyle.replace(/font:\s*[^;]+;?/gi, '')
          elStyle = `font-family: Times New Roman; font-size: ${fontSize}pt; ${elStyle}`.trim()
          elStyle = elStyle.replace(/;\s*;/g, ';').replace(/^\s*;\s*/, '').replace(/\s*;\s*$/, '')
          el.setAttribute('style', elStyle)
        })
      })
      
      // Получаем обновленный HTML
      const updatedHtml = tempDiv.innerHTML
      
      // Обновляем содержимое редактора
      sunEditorInstanceRef.current.setContents(updatedHtml)
      
      // Вызываем onChange для сохранения изменений
      props.onChange(updatedHtml)
    } catch (e) {
      console.error('Error applying font to table:', e)
    }
  }, [props])

  const handleApplyFont8 = () => {
    applyFontToTable(8)
  }

  const handleApplyFont10 = () => {
    applyFontToTable(10)
  }

  const handleApplyFont12 = () => {
    applyFontToTable(12)
  }

  const handleApplyFont14 = () => {
    applyFontToTable(14)
  }

  return (
    <>
    <div className={styles.table} style={{"paddingBottom": "100px"}}>
      {props.fieldInfo.label && <div>{props.fieldInfo.label}</div>}
      <SunEditor
        lang='ru'
        width='fit-content'
        height='auto'
        mode='balloon-always'
        getSunEditorInstance={handleEditorLoad}
        //defaultTag='table'
        setOptions={{
          mode: 'balloon-always',
          "addTagsWhitelist": "table",
          "buttonList": [
            [
              "table", "font", "image", "list", "toggleVerticalText", "toggleHorizontalText"
            ]
          ],
          plugins: [table, font, image, list, video, ...tableVerticalTextPlugins],
        }}
        setContents={noContent ? props.htmlTable : props.value}
        onChange={props.onChange}
        //onScroll={(e) => false}
      />
    </div>
    {/* Кнопки для применения шрифта Times New Roman */}
    <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
    <Button
        variant="outlined"
        color="primary"
        onClick={handleApplyFont8}
        size="small"
        sx={{
          fontSize: '12px',
          fontFamily: 'Times New Roman'
        }}
      >
        Шрифт Times New Roman 8
      </Button>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleApplyFont10}
        size="small"
        sx={{
          fontSize: '12px',
          fontFamily: 'Times New Roman'
        }}
      >
        Шрифт Times New Roman 10
      </Button>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleApplyFont12}
        size="small"
        sx={{
          fontSize: '12px',
          fontFamily: 'Times New Roman'
        }}
      >
        Шрифт Times New Roman 12
      </Button>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleApplyFont14}
        size="small"
        sx={{
          fontSize: '12px',
          fontFamily: 'Times New Roman'
        }}
      >
        Шрифт Times New Roman 14
      </Button>
    </div>
    </>
  )
}

function TableNewControllable(props) {
  const noContent = !props.value || /^<p>([\u200B\s]|<br>)*<\/p>$/.test(props.value)
  const [addRowDialogOpen, setAddRowDialogOpen] = React.useState(false)
  const [rowData, setRowData] = React.useState({})
  const [editingRowIndex, setEditingRowIndex] = React.useState(null)
  const [editingRowHtml, setEditingRowHtml] = React.useState(null)
  const [columnHeaders, setColumnHeaders] = React.useState([])
  const editorRef = React.useRef(null)
  const sunEditorInstanceRef = React.useRef(null)
  
  React.useEffect(() => {
    if(noContent) {
      props.onChange(props.data)
    }
  }, [props.value])

  // Функция для извлечения заголовков столбцов из таблицы
  const extractColumnHeaders = React.useCallback(() => {
    try {
      // Получаем актуальный HTML из редактора
      let currentHtml = props.value || props.data
      if (sunEditorInstanceRef.current) {
        try {
          const editorContents = sunEditorInstanceRef.current.getContents(true)
          if (editorContents) {
            currentHtml = editorContents
          }
        } catch (e) {
          // Игнорируем ошибку
        }
      }
      
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = currentHtml
      
      const table = tempDiv.querySelector('table')
      if (!table) return []
      
      const tbody = table.querySelector('tbody')
      if (!tbody) return []
      
      const rows = Array.from(tbody.querySelectorAll('tr'))
      const headerLength = props.fieldInfo?.headerLength || 1
      const headers = []
      
      // Находим индекс первой строки заголовка
      let firstHeaderRowIndex = -1
      for (let i = 0; i < rows.length; i++) {
        const row = rows[i]
        const firstCell = row.querySelector('td')
        if (!firstCell) continue
        
        const cellStyle = firstCell.getAttribute('style') || ''
        // Если это строка заголовка (border-top: 3px)
        if (cellStyle.includes('border-top: 3px') || cellStyle.includes('border-top:3px')) {
          firstHeaderRowIndex = i
          break
        }
      }
      
      // Если не нашли строку с border-top: 3px, используем первую строку
      if (firstHeaderRowIndex === -1 && rows.length > 0) {
        firstHeaderRowIndex = 0
      }
      
      // Обрабатываем headerLength строк начиная с firstHeaderRowIndex
      if (firstHeaderRowIndex >= 0) {
        const headerRows = rows.slice(firstHeaderRowIndex, firstHeaderRowIndex + headerLength)
        
        // Инициализируем массив заголовков для каждой колонки
        const columnHeaders = []
        
        // Обрабатываем каждую строку заголовков
        headerRows.forEach((row) => {
          const cells = row.querySelectorAll('td')
          let colIndex = 0
          
          cells.forEach((cell) => {
            let text = (cell.textContent || cell.innerText || '').trim()
            // Заменяем переносы строк на пробелы
            text = text.replace(/\n/g, ' ').replace(/\r/g, ' ').replace(/<br\s*\/?>/gi, ' ').replace(/\s+/g, ' ').trim()
            const colspan = parseInt(cell.getAttribute('colspan') || '1', 10)
            
            // Пропускаем ячейки с только цифрами (номера колонок)
            const isNumberOnly = /^[0-9]+$/.test(text)
            
            // Устанавливаем заголовок для текущей колонки и следующих (если есть colspan)
            for (let j = 0; j < colspan; j++) {
              const currentColIndex = colIndex + j
              
              // Инициализируем массив для этой колонки, если еще не создан
              if (!columnHeaders[currentColIndex]) {
                columnHeaders[currentColIndex] = []
              }
              
              // Добавляем текст заголовка, если это не только цифры
              if (!isNumberOnly && text) {
                columnHeaders[currentColIndex].push(text)
              }
            }
            
            colIndex += colspan
          })
        })
        
        // Объединяем заголовки из всех строк для каждой колонки
        columnHeaders.forEach((headerParts, index) => {
          if (headerParts.length > 0) {
            // Объединяем части заголовка через пробел
            headers[index] = headerParts.join(' ').trim()
          } else {
            headers[index] = `Колонка ${index + 1}`
          }
        })
      }
      
      // Убеждаемся, что у нас есть заголовки для всех колонок
      while (headers.length < props.fieldInfo?.rowColumns) {
        headers.push(`Колонка ${headers.length + 1}`)
      }
      
      return headers.slice(0, props.fieldInfo?.rowColumns || headers.length)
    } catch (e) {
      console.warn('Failed to extract column headers:', e)
      // Возвращаем дефолтные заголовки
      return Array.from({ length: props.fieldInfo?.rowColumns || 0 }, (_, i) => `Колонка ${i + 1}`)
    }
  }, [props.value, props.data, props.fieldInfo?.rowColumns, props.fieldInfo?.headerLength])

  const handleAddRow = React.useCallback(() => {
    if (!props.fieldInfo?.rowColumns) {
      return
    }

    // Извлекаем заголовки столбцов
    const headers = extractColumnHeaders()
    setColumnHeaders(headers)

    // Инициализируем пустые значения для всех колонок
    const initialData = {}
    for (let i = 1; i <= props.fieldInfo.rowColumns; i++) {
      initialData[`col${i}`] = ''
    }
    setRowData(initialData)
    setAddRowDialogOpen(true)
  }, [props.fieldInfo?.rowColumns, extractColumnHeaders])

  const handleEditRow = React.useCallback((rowIndex, rowElement) => {
    if (!props.fieldInfo?.rowColumns) {
      return
    }

    // Извлекаем заголовки столбцов
    const headers = extractColumnHeaders()
    setColumnHeaders(headers)

    // Извлекаем данные из строки
    const cells = rowElement.querySelectorAll('td')
    const initialData = {}
    for (let i = 0; i < Math.min(cells.length, props.fieldInfo.rowColumns); i++) {
      const cell = cells[i]
      // Извлекаем текст из ячейки, убирая HTML теги
      const text = cell.textContent || cell.innerText || ''
      initialData[`col${i + 1}`] = text.trim()
    }
    
    // Сохраняем HTML строки для идентификации при сохранении
    const rowHtml = rowElement.outerHTML
    
    setRowData(initialData)
    setEditingRowIndex(rowIndex)
    setEditingRowHtml(rowHtml)
    setAddRowDialogOpen(true)
  }, [props.fieldInfo?.rowColumns, extractColumnHeaders])

  const handleDeleteRow = React.useCallback((rowIndex, rowElement) => {
    if (!window.confirm('Вы уверены, что хотите удалить эту строку?')) {
      return
    }
    
    // Получаем актуальный HTML из редактора
    let currentHtml = props.value || props.data
    if (sunEditorInstanceRef.current) {
      try {
        const editorContents = sunEditorInstanceRef.current.getContents(true)
        if (editorContents) {
          currentHtml = editorContents
        }
      } catch (e) {
        console.warn('Failed to get contents from editor:', e)
      }
    }
    
    // Создаем временный DOM элемент для парсинга HTML
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = currentHtml
    
    // Находим таблицу
    const table = tempDiv.querySelector('table')
    if (!table) {
      tempDiv.innerHTML = props.data
      const initialTable = tempDiv.querySelector('table')
      if (!initialTable) {
        console.error('Table not found')
        return
      }
    }

    // Находим tbody
    let tbody = table.querySelector('tbody')
    if (!tbody) {
      return
    }

    const rows = tbody.querySelectorAll('tr')
    
    // Находим строку для удаления
    let rowToDelete = null
    
    // Извлекаем идентификатор из HTML строки
    const rowHtml = rowElement.outerHTML
    const tempRowDiv = document.createElement('div')
    tempRowDiv.innerHTML = rowHtml
    const originalRow = tempRowDiv.querySelector('tr')
    if (originalRow) {
      const originalFirstCell = originalRow.querySelector('td')
      const originalText = originalFirstCell ? (originalFirstCell.textContent || originalFirstCell.innerText || '').trim() : ''
      
      // Ищем строку с таким же содержимым первой ячейки
      rows.forEach((row) => {
        const firstCell = row.querySelector('td')
        if (firstCell && !rowToDelete) {
          const cellText = (firstCell.textContent || firstCell.innerText || '').trim()
          
          // Сравниваем первые символы для идентификации строки
          if (originalText && cellText && cellText.substring(0, 20) === originalText.substring(0, 20)) {
            rowToDelete = row
          }
        }
      })
    }
    
    // Если не нашли по содержимому, используем индекс
    if (!rowToDelete) {
      const dataRows = []
      rows.forEach((row) => {
        const firstCell = row.querySelector('td')
        if (firstCell) {
          dataRows.push(row)
        }
      })
      
      if (dataRows[rowIndex]) {
        rowToDelete = dataRows[rowIndex]
      }
    }

    if (rowToDelete) {
      rowToDelete.remove()
      
      // Удаляем кнопки редактирования и удаления из HTML перед сохранением
      const buttons = tempDiv.querySelectorAll('.edit-row-button, .delete-row-button')
      buttons.forEach(button => button.remove())
      
      // Также удаляем атрибут position: relative со строк, если он был добавлен только для кнопок
      const rowsWithPosition = tempDiv.querySelectorAll('tr[style*="position: relative"]')
      rowsWithPosition.forEach(row => {
        const hasButtons = row.querySelector('.edit-row-button, .delete-row-button')
        if (!hasButtons) {
          const style = row.getAttribute('style') || ''
          const newStyle = style.replace(/position:\s*relative[^;]*;?/gi, '').trim()
          if (newStyle) {
            row.setAttribute('style', newStyle)
          } else {
            row.removeAttribute('style')
          }
        }
      })
      
      // Получаем обновленный HTML
      const updatedHtml = tempDiv.innerHTML
      
      // Обновляем значение через onChange
      props.onChange(updatedHtml)
      
      // Явно обновляем контент в редакторе
      if (sunEditorInstanceRef.current) {
        try {
          sunEditorInstanceRef.current.setContents(updatedHtml)
        } catch (e) {
          console.warn('Failed to update editor contents:', e)
        }
      }
    }
  }, [props])

  const handleEditorLoad = React.useCallback((sunEditor) => {
    // Сохраняем ссылку на экземпляр редактора
    sunEditorInstanceRef.current = sunEditor
    
    // Добавляем обработчик вставки для фильтрации контента (только текст)
    if (sunEditor && sunEditor.core) {
      try {
        const editorElement = sunEditor.core.context?.element?.wysiwygFrame || 
                             sunEditor.core.context?.element?.wysiwyg ||
                             document.querySelector('.se-wrapper-wysiwyg iframe')
        
        if (editorElement) {
          const doc = editorElement.contentDocument || editorElement.contentWindow?.document || editorElement
          if (doc) {
            // Перехватываем событие paste
            doc.addEventListener('paste', (e) => {
              e.preventDefault()
              e.stopPropagation()
              
              // Получаем только текст из буфера обмена
              const clipboardData = e.clipboardData || window.clipboardData
              const text = clipboardData.getData('text/plain')
              
              if (text) {
                // Используем API SunEditor для вставки текста
                try {
                  // Получаем выделение через core API
                  const selection = sunEditor.core.getSelection()
                  if (selection && selection.rangeCount > 0) {
                    const range = selection.getRangeAt(0)
                    range.deleteContents()
                    const textNode = doc.createTextNode(text)
                    range.insertNode(textNode)
                    range.setStartAfter(textNode)
                    selection.removeAllRanges()
                    selection.addRange(range)
                    
                    // Сохраняем изменения
                    sunEditor.core.context.disable = false
                    sunEditor.save()
                  } else {
                    // Если нет выделения, используем insertHTML
                    sunEditor.insertHTML(text)
                  }
                } catch (err) {
                  // Fallback: используем insertHTML
                  sunEditor.insertHTML(text)
                }
              }
            }, true)
          }
        }
      } catch (e) {
        console.warn('Failed to add paste handler:', e)
      }
    }
    
    if (sunEditor && !sunEditor._addRowButtonAdded) {
      sunEditor._addRowButtonAdded = true
      
      // Добавляем обработчики для строк таблицы
      const addRowEditButtons = () => {
        try {
          // Получаем элемент редактора
          let editorElement = sunEditor.core?.context?.element?.wysiwygFrame || 
                             sunEditor.core?.context?.element?.wysiwyg ||
                             document.querySelector('.se-wrapper-wysiwyg iframe')
          
          if (!editorElement) return

          // Получаем документ iframe или используем document если это не iframe
          let doc = null
          let container = null
          
          if (editorElement.tagName === 'IFRAME') {
            // Это iframe, получаем его документ
            if (editorElement.contentDocument) {
              doc = editorElement.contentDocument
              container = doc
            } else if (editorElement.contentWindow) {
              doc = editorElement.contentWindow.document
              container = doc
            }
          } else {
            // Это не iframe (div), используем document для создания элементов
            doc = document
            container = editorElement
          }

          if (!doc || typeof doc.createElement !== 'function') {
            console.warn('Cannot get document for SunEditor', { doc, editorElement })
            return
          }

          const tables = container.querySelectorAll('table')
          tables.forEach(table => {
            // Получаем все строки из tbody
            const tbody = table.querySelector('tbody')
            if (!tbody) return
            
            const rows = Array.from(tbody.querySelectorAll('tr'))
            let dataRowIndex = 0
            
            // Находим строку с номерами колонок (обычно имеет border-bottom: 3px)
            let headerRowIndex = -1
            // rows.forEach((row, idx) => {
            //   const firstCell = row.querySelector('td')
            //   if (firstCell) {
            //     const cellStyle = firstCell.getAttribute('style') || ''
            //     if (cellStyle.includes('border-bottom: 3px') || 
            //         cellStyle.includes('border-bottom:3px')) {
            //       headerRowIndex = idx
            //     }
            //   }
            // })
            
            rows.forEach((row, idx) => {
              // Пропускаем строки заголовков (до строки с номерами колонок включительно)
              if (headerRowIndex >= 0 && idx <= headerRowIndex) {
                return
              }
              
              // Пропускаем строки без ячеек
              const firstCell = row.querySelector('td')
              if (!firstCell) return
              
              // Пропускаем строки заголовков (с border-top: 3px)
              const cellStyle = firstCell.getAttribute('style') || ''
              // if (cellStyle.includes('border-top: 3px') || 
              //     cellStyle.includes('border-top:3px')) {
              //   return
              // }
              
              // Пропускаем полностью пустые строки (все ячейки пустые или содержат только пробелы/переносы строк)
              const cells = row.querySelectorAll('td')
              const hasContent = cells.length > 0 && Array.from(cells).some(cell => {
                const text = (cell.textContent || cell.innerText || '').trim()
                // Считаем строку с содержимым, если есть хотя бы один символ (не только пробелы)
                return text.length > 0 && text !== '<br>' && text !== '&nbsp;'
              })
              
              // Если строка полностью пустая, пропускаем её
              if (!hasContent && cells.length > 0) {
                return
              }

              const currentIndex = dataRowIndex++
              
              // Удаляем старую кнопку если есть
              const oldButton = row.querySelector('.edit-row-button')
              if (oldButton) {
                oldButton.remove()
              }
              
              // Создаем кнопку редактирования
              const editButton = doc.createElement('button')
              editButton.className = 'edit-row-button'
              editButton.innerHTML = '✏️'
              editButton.title = 'Редактировать строку'
              const rowIndex = currentIndex
              const startContentIndex = props.fieldInfo?.startContentIndex || 0
              const canDelete = currentIndex >= startContentIndex
              
              // Объявляем deleteButton вне блока if для использования в обработчиках
              let deleteButton = null
              
              // Добавляем кнопку удаления, если индекс >= startContentIndex
              if (canDelete) {
                deleteButton = doc.createElement('button')
                deleteButton.className = 'delete-row-button'
                deleteButton.innerHTML = '🗑️'
                deleteButton.title = 'Удалить строку'
                deleteButton.style.cssText = `
                  position: absolute;
                  right: 5px;
                  top: 50%;
                  transform: translateY(-50%);
                  background: #d32f2f;
                  color: white;
                  border: none;
                  border-radius: 4px;
                  padding: 4px 8px;
                  cursor: pointer;
                  font-size: 12px;
                  opacity: 0;
                  transition: opacity 0.2s;
                  z-index: 1000;
                  pointer-events: auto;
                `
                
                deleteButton.onclick = (e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  handleDeleteRow(rowIndex, row)
                }
                
                // Делаем строку относительно позиционированной
                if (row.style.position !== 'relative') {
                  row.style.position = 'relative'
                }
                row.appendChild(deleteButton)
              }
              
              editButton.style.cssText = `
                position: absolute;
                right: 35px;
                top: 50%;
                transform: translateY(-50%);
                background: #1976d2;
                color: white;
                border: none;
                border-radius: 4px;
                padding: 4px 8px;
                cursor: pointer;
                font-size: 12px;
                opacity: 0;
                transition: opacity 0.2s;
                z-index: 1000;
                pointer-events: auto;
              `
              
              editButton.onclick = (e) => {
                e.preventDefault()
                e.stopPropagation()
                handleEditRow(rowIndex, row)
              }
              
              // Делаем строку относительно позиционированной
              if (row.style.position !== 'relative') {
                row.style.position = 'relative'
              }
              
              // Добавляем кнопки в правильном порядке: сначала редактирование, потом удаление
              row.appendChild(editButton)
              
              // Добавляем hover эффект
              const originalMouseEnter = row.onmouseenter
              const originalMouseLeave = row.onmouseleave
              
              if (canDelete && deleteButton) {
                // Обе кнопки
                row.onmouseenter = (e) => {
                  if (originalMouseEnter) originalMouseEnter(e)
                  editButton.style.opacity = '1'
                  deleteButton.style.opacity = '1'
                }
                
                row.onmouseleave = (e) => {
                  if (originalMouseLeave) originalMouseLeave(e)
                  editButton.style.opacity = '0'
                  deleteButton.style.opacity = '0'
                }
              } else {
                // Только кнопка редактирования
                row.onmouseenter = (e) => {
                  if (originalMouseEnter) originalMouseEnter(e)
                  editButton.style.opacity = '1'
                }
                
                row.onmouseleave = (e) => {
                  if (originalMouseLeave) originalMouseLeave(e)
                  editButton.style.opacity = '0'
                }
              }
            })
          })
        } catch (e) {
          console.warn('Failed to add edit buttons to table rows:', e)
        }
      }

      // Добавляем обработчики после загрузки контента
      const initButtons = () => {
        // Пробуем несколько раз с задержками, так как контент может загружаться асинхронно
        //setTimeout(() => addRowEditButtons(), 300)
        //setTimeout(() => addRowEditButtons(), 800)
        setTimeout(() => addRowEditButtons(), 1500)
      }
      
      initButtons()
      
      // Сохраняем оригинальный onChange
      const originalOnChange = sunEditor.onChange
      
      // Обновляем при изменении контента
      sunEditor.onChange = (contents, core) => {
        // Удаляем кнопки из содержимого перед передачей в onChange
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = contents
        const buttons = tempDiv.querySelectorAll('.edit-row-button, .delete-row-button')
        buttons.forEach(button => button.remove())
        
        // Также удаляем атрибут position: relative со строк, если он был добавлен только для кнопок
        const rowsWithPosition = tempDiv.querySelectorAll('tr[style*="position: relative"]')
        rowsWithPosition.forEach(row => {
          const hasButtons = row.querySelector('.edit-row-button, .delete-row-button')
          if (!hasButtons) {
            const style = row.getAttribute('style') || ''
            const newStyle = style.replace(/position:\s*relative[^;]*;?/gi, '').trim()
            if (newStyle) {
              row.setAttribute('style', newStyle)
            } else {
              row.removeAttribute('style')
            }
          }
        })
        
        const cleanedContents = tempDiv.innerHTML
        
        if (originalOnChange) {
          originalOnChange(cleanedContents, core)
        }
        // Добавляем кнопки после небольшой задержки
        setTimeout(() => {
          addRowEditButtons()
        }, 300)
      }
      
      // Также добавляем обработчик на событие загрузки контента
      if (sunEditor.core) {
        const originalSetContents = sunEditor.core.setContents
        if (originalSetContents) {
          sunEditor.core.setContents = function(contents) {
            const result = originalSetContents.call(this, contents)
            setTimeout(() => {
              addRowEditButtons()
            }, 300)
            return result
          }
        }
      }
    }
  }, [handleEditRow, handleDeleteRow, props.fieldInfo?.startContentIndex])

  const handleSaveRow = () => {
    // Получаем актуальный HTML из редактора
    let currentHtml = props.value || props.data
    if (sunEditorInstanceRef.current) {
      try {
        const editorContents = sunEditorInstanceRef.current.getContents(true)
        if (editorContents) {
          currentHtml = editorContents
        }
      } catch (e) {
        console.warn('Failed to get contents from editor:', e)
      }
    }
    
    // Создаем временный DOM элемент для парсинга HTML
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = currentHtml
    
    // Находим таблицу
    const table = tempDiv.querySelector('table')
    if (!table) {
      // Если таблицы нет, используем начальную таблицу
      tempDiv.innerHTML = props.data
      const initialTable = tempDiv.querySelector('table')
      if (!initialTable) {
        console.error('Table not found')
        return
      }
    }

    // Находим tbody или создаем его
    let tbody = table.querySelector('tbody')
    if (!tbody) {
      tbody = document.createElement('tbody')
      table.appendChild(tbody)
    }

    const rows = tbody.querySelectorAll('tr')
    
    // Если редактируем существующую строку
    if (editingRowIndex !== null && editingRowHtml) {
      // Находим строку для редактирования по её содержимому
      // Используем первые несколько символов из первой ячейки для идентификации
      let rowToEdit = null
      
      // Извлекаем идентификатор из сохраненного HTML
      const tempRowDiv = document.createElement('div')
      tempRowDiv.innerHTML = editingRowHtml
      const originalRow = tempRowDiv.querySelector('tr')
      if (originalRow) {
        const originalFirstCell = originalRow.querySelector('td')
        const originalText = originalFirstCell ? (originalFirstCell.textContent || originalFirstCell.innerText || '').trim() : ''
        
        // Ищем строку с таким же содержимым первой ячейки
        rows.forEach((row) => {
          const firstCell = row.querySelector('td')
          if (firstCell && !rowToEdit) {
            const cellText = (firstCell.textContent || firstCell.innerText || '').trim()
            const cellStyle = firstCell.getAttribute('style') || ''
            
            // Пропускаем заголовки
            // if (cellStyle.includes('border-bottom: 3px') || 
            //     cellStyle.includes('border-bottom:3px') ||
            //     cellStyle.includes('border-top: 3px') ||
            //     cellStyle.includes('border-top:3px') ||
            //     /^[0-9]+$/.test(cellText)) {
            //   return
            // }
            
            // Сравниваем первые символы для идентификации строки
            if (originalText && cellText && cellText.substring(0, 20) === originalText.substring(0, 20)) {
              rowToEdit = row
            }
          }
        })
      }
      
      // Если не нашли по содержимому, используем индекс
      if (!rowToEdit) {
        const dataRows = []
        rows.forEach((row) => {
          const firstCell = row.querySelector('td')
          if (firstCell) {
            const cellStyle = firstCell.getAttribute('style') || ''
            const cellText = firstCell.textContent.trim()
            dataRows.push(row)
            // if (!cellStyle.includes('border-bottom: 3px') && 
            //     !cellStyle.includes('border-bottom:3px') &&
            //     !cellStyle.includes('border-top: 3px') &&
            //     !cellStyle.includes('border-top:3px') &&
            //     !/^[0-9]+$/.test(cellText)) {
              
            // }
          }
        })
        
        if (dataRows[editingRowIndex]) {
          rowToEdit = dataRows[editingRowIndex]
        }
      }

      if (rowToEdit) {
        const cells = rowToEdit.querySelectorAll('td')
        
        // Обновляем данные в ячейках
        for (let i = 0; i < Math.min(cells.length, props.fieldInfo.rowColumns); i++) {
          const cell = cells[i]
          const value = rowData[`col${i + 1}`] || ''
          
          // Экранируем HTML для безопасности
          const escapedValue = value
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
          
          cell.innerHTML = `<font face="Times New Roman" size="3" color="#000000">${escapedValue}</font>`
        }
      } else {
        console.warn('Row to edit not found', { editingRowIndex, editingRowHtml })
      }
    } else {
      // Добавляем новую строку
      // Находим место для вставки новой строки
      let insertAfterRow = null
      
      // Ищем последнюю строку с border-bottom: 3px (обычно это строка с номерами колонок перед данными)
      for (let i = rows.length - 1; i >= 0; i--) {
        const row = rows[i]
        const firstCell = row.querySelector('td')
        if (firstCell) {
          const cellStyle = firstCell.getAttribute('style') || ''
          if (cellStyle.includes('border-bottom: 3px') || cellStyle.includes('border-bottom:3px')) {
            insertAfterRow = row
            break
          }
        }
      }
      
      // Если не нашли строку с border-bottom: 3px, ищем последнюю строку данных
      if (!insertAfterRow) {
        for (let i = rows.length - 1; i >= 0; i--) {
          const row = rows[i]
          const firstCell = row.querySelector('td')
          if (firstCell) {
            const cellText = firstCell.textContent.trim()
            const cellStyle = firstCell.getAttribute('style') || ''
            if (cellText !== '' &&
                !cellStyle.includes('rowspan')) {
              insertAfterRow = row
              break
            }
          }
        }
      }

      const referenceRow = insertAfterRow || rows[rows.length - 1]
      
      // Создаем новую строку
      const newRow = document.createElement('tr')
      
      // Получаем стили из строки с номерами колонок (border-bottom: 3px) или из последней строки
      let styleRow = null
      for (let i = rows.length - 1; i >= 0; i--) {
        const row = rows[i]
        const firstCell = row.querySelector('td')
        if (firstCell) {
          const cellStyle = firstCell.getAttribute('style') || ''
          if (cellStyle.includes('border-bottom: 3px') || cellStyle.includes('border-bottom:3px')) {
            styleRow = row
            break
          }
        }
      }
      if (!styleRow && rows.length > 0) {
        styleRow = rows[rows.length - 1]
      }
      const styleCells = styleRow ? styleRow.querySelectorAll('td') : []
      
      // Создаем ячейки для новой строки
      for (let i = 1; i <= props.fieldInfo.rowColumns; i++) {
        const newCell = document.createElement('td')
        const value = rowData[`col${i}`] || ''
        
        // Копируем стили из соответствующей ячейки или используем стандартные
        if (styleCells[i - 1]) {
          const styleCell = styleCells[i - 1]
          const cellStyle = styleCell.getAttribute('style') || ''
          const modifiedStyle = cellStyle
            .replace(/border-top:\s*3px[^;]*;?/gi, 'border-top: 1px solid #000000;')
            .replace(/border-top:3px[^;]*;?/gi, 'border-top: 1px solid #000000;')
          newCell.setAttribute('style', modifiedStyle || 'border: 1px solid #000000; padding: 5px;')
        } else {
          newCell.setAttribute('style', 'border: 1px solid #000000; padding: 5px;')
        }
        
        // Экранируем HTML для безопасности
        const escapedValue = value
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;')
        newCell.innerHTML = `<font face="Times New Roman" size="3" color="#000000">${escapedValue}</font>`
        newRow.appendChild(newCell)
      }

      // Вставляем новую строку после referenceRow
      if (referenceRow && referenceRow.nextSibling) {
        tbody.insertBefore(newRow, referenceRow.nextSibling)
      } else {
        tbody.appendChild(newRow)
      }
    }

    // Удаляем кнопки редактирования и удаления из HTML перед сохранением
    const buttons = tempDiv.querySelectorAll('.edit-row-button, .delete-row-button')
    buttons.forEach(button => button.remove())
    
    // Также удаляем атрибут position: relative со строк, если он был добавлен только для кнопок
    const rowsWithPosition = tempDiv.querySelectorAll('tr[style*="position: relative"]')
    rowsWithPosition.forEach(row => {
      const hasButtons = row.querySelector('.edit-row-button, .delete-row-button')
      if (!hasButtons) {
        const style = row.getAttribute('style') || ''
        const newStyle = style.replace(/position:\s*relative[^;]*;?/gi, '').trim()
        if (newStyle) {
          row.setAttribute('style', newStyle)
        } else {
          row.removeAttribute('style')
        }
      }
    })
    
    // Получаем обновленный HTML
    const updatedHtml = tempDiv.innerHTML
    
    // Обновляем значение через onChange
    props.onChange(updatedHtml)
    
    // Явно обновляем контент в редакторе
    if (sunEditorInstanceRef.current) {
      try {
        sunEditorInstanceRef.current.setContents(updatedHtml)
      } catch (e) {
        console.warn('Failed to update editor contents:', e)
      }
    }
    
    // Закрываем диалог и очищаем данные
    setAddRowDialogOpen(false)
    setRowData({})
    setEditingRowIndex(null)
    setEditingRowHtml(null)
  }

  const handleCancelRow = () => {
    setAddRowDialogOpen(false)
    setRowData({})
    setEditingRowIndex(null)
    setEditingRowHtml(null)
  }

  // Функция для применения шрифта Times New Roman указанного размера ко всему контенту таблицы
  const applyFontToTable = React.useCallback((fontSize) => {
    if (!sunEditorInstanceRef.current) {
      console.warn('SunEditor instance not available')
      return
    }

    try {
      // Получаем текущий HTML из редактора
      let currentHtml = sunEditorInstanceRef.current.getContents(true) || props.value || props.data
      
      // Создаем временный DOM элемент для парсинга HTML
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = currentHtml
      
      // Находим таблицу
      const table = tempDiv.querySelector('table')
      if (!table) {
        console.warn('Table not found')
        return
      }
      
      // Применяем шрифт и размер ко всем ячейкам таблицы
      const cells = table.querySelectorAll('td, th')
      cells.forEach(cell => {
        // Получаем текущий стиль или создаем новый
        let style = cell.getAttribute('style') || ''
        
        // Удаляем старые значения font-family и font-size
        style = style.replace(/font-family:\s*[^;]+;?/gi, '')
        style = style.replace(/font-size:\s*[^;]+;?/gi, '')
        style = style.replace(/font:\s*[^;]+;?/gi, '')
        
        // Добавляем новый шрифт и размер
        style = `font-family: Times New Roman; font-size: ${fontSize}pt; ${style}`.trim()
        
        // Удаляем лишние пробелы и точки с запятой
        style = style.replace(/;\s*;/g, ';').replace(/^\s*;\s*/, '').replace(/\s*;\s*$/, '')
        
        cell.setAttribute('style', style)
        
        // Также применяем к вложенным элементам (span, p, div и т.д.)
        const innerElements = cell.querySelectorAll('span, p, div, font')
        innerElements.forEach(el => {
          let elStyle = el.getAttribute('style') || ''
          elStyle = elStyle.replace(/font-family:\s*[^;]+;?/gi, '')
          elStyle = elStyle.replace(/font-size:\s*[^;]+;?/gi, '')
          elStyle = elStyle.replace(/font:\s*[^;]+;?/gi, '')
          elStyle = `font-family: Times New Roman; font-size: ${fontSize}pt; ${elStyle}`.trim()
          elStyle = elStyle.replace(/;\s*;/g, ';').replace(/^\s*;\s*/, '').replace(/\s*;\s*$/, '')
          el.setAttribute('style', elStyle)
        })
      })
      
      // Получаем обновленный HTML
      const updatedHtml = tempDiv.innerHTML
      
      // Обновляем содержимое редактора
      sunEditorInstanceRef.current.setContents(updatedHtml)
      
      // Вызываем onChange для сохранения изменений
      props.onChange(updatedHtml)
    } catch (e) {
      console.error('Error applying font to table:', e)
    }
  }, [props])

  const handleApplyFont12 = () => {
    applyFontToTable(12)
  }

  const handleApplyFont14 = () => {
    applyFontToTable(14)
  }

  return (
    <div className={styles.table} style={{"paddingBottom": "100px"}}>
      {props.fieldInfo?.label && <div>{props.fieldInfo.label}</div>}
      <div>TEST</div>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <SunEditor
          getSunEditorInstance={handleEditorLoad}
          lang='ru'
          width='fit-content'
          height='auto'
          mode='balloon-always'
          //defaultTag='table'
          setOptions={{
            mode: 'balloon-always',
            //"addTagsWhitelist": "table",
            "buttonList": [
              [
                "font", "fontSize", "image", "list"
              ]
            ],
            plugins: [font, fontSize, image, list, video],
            // Настройки шрифтов
            "font": [
              "Arial",
              "Comic Sans MS",
              "Courier New",
              "Impact",
              "Georgia",
              "Tahoma",
              "Times New Roman",
              "Trebuchet MS",
              "Verdana"
            ],
            // Настройки размеров шрифта (без единиц измерения)
            "fontSize": [
              "8", "9", "10", "11", "12", "14", "16", "18", "20", "22", "24", "26", "28", "36", "48", "72"
            ],
            // Запрещаем вставку таблиц и других элементов, разрешаем только текст
            "pasteTagsWhitelist": "p|br|span|strong|b|em|i|u|s|strike|sub|sup|font",
            "pasteTagsBlacklist": "table|thead|tbody|tfoot|tr|td|th|div|ul|ol|li|h1|h2|h3|h4|h5|h6|img|video|iframe|object|embed|form|input|button|select|textarea",
            "pasteKeepAttributes": false,
            "pasteKeepClass": false,
          }}
          onPaste={(e, cleanData, maxCharCount) => {
            // Дополнительная фильтрация при вставке - оставляем только текст
            try {
              const tempDiv = document.createElement('div')
              tempDiv.innerHTML = cleanData
              
              // Удаляем все таблицы и другие запрещенные элементы
              tempDiv.querySelectorAll('table, thead, tbody, tfoot, tr, td, th, div, ul, ol, li, h1, h2, h3, h4, h5, h6, img, video, iframe, object, embed, form, input, button, select, textarea').forEach(el => {
                // Заменяем на текст
                const text = el.textContent || ''
                const textNode = document.createTextNode(text)
                el.parentNode?.replaceChild(textNode, el)
              })
              
              // Возвращаем только текст
              return tempDiv.textContent || tempDiv.innerText || ''
            } catch (err) {
              console.warn('Error filtering paste content:', err)
              // В случае ошибки возвращаем только текст из cleanData
              const tempDiv = document.createElement('div')
              tempDiv.innerHTML = cleanData
              return tempDiv.textContent || tempDiv.innerText || ''
            }
          }}
          setContents={noContent ? props.htmlTable : props.value}
          onChange={props.onChange}
          //onScroll={(e) => false}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleAddRow}
          size="small"
          startIcon={<span style={{ fontSize: '16px' }}>➕</span>}
          sx={{
            position: 'absolute',
            top: '5px',
            right: '5px',
            zIndex: 1000,
            minWidth: 'auto',
            padding: '4px 12px',
            fontSize: '12px'
          }}
        >
          Добавить
        </Button>
      </div>
      
      {/* Кнопки для применения шрифта Times New Roman */}
      <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleApplyFont12}
          size="small"
          sx={{
            fontSize: '12px',
            fontFamily: 'Times New Roman'
          }}
        >
          Шрифт Times New Roman 12
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleApplyFont14}
          size="small"
          sx={{
            fontSize: '12px',
            fontFamily: 'Times New Roman'
          }}
        >
          Шрифт Times New Roman 14
        </Button>
      </div>
      
      <Dialog
        open={addRowDialogOpen}
        onClose={handleCancelRow}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{editingRowIndex !== null ? 'Редактировать строку' : 'Добавить строку в таблицу'}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ marginTop: 1 }}>
            {Array.from({ length: props.fieldInfo.rowColumns || 0 }, (_, i) => i + 1).map((colNum) => {
              const headerText = columnHeaders[colNum - 1] || `Колонка ${colNum}`
              return (
                <Grid key={colNum} container alignItems="center" sx={{ marginBottom: 2 }}>
                  <Grid item sx={{ width: '30%', minWidth: '30%', maxWidth: '30%', paddingRight: 2 }}>
                    <Typography sx={{ fontWeight: 500 }}>
                      {headerText}:
                    </Typography>
                  </Grid>
                  <Grid item xs sx={{ paddingLeft: 0 }}>
                    <TextField
                      value={rowData[`col${colNum}`] || ''}
                      onChange={(e) => {
                        setRowData(prev => ({
                          ...prev,
                          [`col${colNum}`]: e.target.value
                        }))
                      }}
                      fullWidth
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              )
            })}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelRow}>Отмена</Button>
          <Button onClick={handleSaveRow} variant="contained" color="primary">
            {editingRowIndex !== null ? 'Сохранить' : 'Добавить'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
